import React from 'react';
import { forwardRef } from 'react';
import { StyledLabel, StyledInput, StyledTextContent, StyledFormMessage, StyledRadioContainer, StyledRadioIndicator } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const RadioButton = forwardRef(({ className, label, id, checked, defaultChecked, value, disabled, name, required, invalid, onChange, readOnly, errorMessage, onClick, onKeyDown, hint, margin, ...rest }, ref) => {
    const hintId = `${id}__hint`;
    const errorMsgId = `${id}__error-msg`;
    const ariaDescribedByProp = pickA11yProps(rest)['aria-describedby'];
    const ariaDescribedBy = hint || (errorMessage && invalid) || ariaDescribedByProp
        ? [
            hint ? hintId : undefined,
            errorMessage && invalid ? errorMsgId : undefined,
            ariaDescribedByProp ? ariaDescribedByProp : undefined
        ]
            .join(' ')
            .trim()
        : undefined;
    return (React.createElement(StyledRadioContainer, { className: className, ref: ref, margin: margin, ...pickDataProps(rest) },
        React.createElement(StyledLabel, { invalid: invalid, "$readOnly": readOnly },
            React.createElement(StyledInput, { type: "radio", checked: checked, defaultChecked: defaultChecked, id: id, value: value, disabled: disabled || readOnly, "$readOnly": readOnly, required: required, onChange: onChange, onClick: onClick, onKeyDown: onKeyDown, name: name, invalid: invalid, ...pickA11yProps(rest), "aria-describedby": ariaDescribedBy }),
            React.createElement(StyledRadioIndicator, { invalid: invalid }),
            React.createElement(StyledTextContent, null, label)),
        hint && (React.createElement(StyledFormMessage, { text: hint, variant: "hint", id: hintId, disabled: disabled })),
        invalid && errorMessage && (React.createElement(StyledFormMessage, { text: errorMessage, variant: "error", id: errorMsgId }))));
});
RadioButton.displayName = 'RadioButton';
//# sourceMappingURL=index.js.map